import {
  IConversationMessage,
  ISentMessage,
} from "../../types/webchatConversation";
import {
  ADD_NEW_MESSAGE,
  ADD_NEW_MESSAGE_SUCCESS_IN_CHAT_LIST,
  CLEAR_CHAT_MESSAGES,
  DELETE_FILE,
  DELETE_FILE_ERROR,
  DELETE_FILE_SUCCESS,
  GET_CONVERSATION,
  GET_CONVERSATION_SUCCESS,
  HIDE_TYPING_INDICATOR,
  RESET_FILE_UPLOAD,
  SHOW_TYPING_INDICATOR,
  UPLOAD_FILE,
  UPLOAD_FILE_ERROR,
  UPLOAD_FILE_SUCCESS,
} from "./constants";

export const addNewMessage = (message: IConversationMessage) => ({
  type: ADD_NEW_MESSAGE,
  payload: {
    message,
  },
});

export const addNewMessageSuccessInChatList = (
  message: IConversationMessage | ISentMessage,
) => ({
  type: ADD_NEW_MESSAGE_SUCCESS_IN_CHAT_LIST,
  payload: {
    message,
  },
});

export const clearChatMessages = () => ({
  type: CLEAR_CHAT_MESSAGES,
});

export const getConversation = () => ({
  type: GET_CONVERSATION,
});

export const getConversationSuccess = (conversationMessages: any) => ({
  type: GET_CONVERSATION_SUCCESS,
  payload: { conversationMessages },
});

export const uploadFile = (file: File) => ({
  type: UPLOAD_FILE,
  payload: { file },
});

export const uploadFileSuccess = (filePath: string) => ({
  type: UPLOAD_FILE_SUCCESS,
  payload: { filePath },
});

export const uploadFileError = (error: string) => ({
  type: UPLOAD_FILE_ERROR,
  payload: { error },
});

export const deleteFile = (filePath: string) => ({
  type: DELETE_FILE,
  payload: { filePath },
});

export const deleteFileSuccess = () => ({
  type: DELETE_FILE_SUCCESS,
});

export const deleteFileError = (error: string) => ({
  type: DELETE_FILE_ERROR,
  payload: { error },
});

export const resetFileUpload = () => ({
  type: RESET_FILE_UPLOAD,
});

export const showTypingIndicator = () => ({
  type: SHOW_TYPING_INDICATOR,
});

export const hideTypingIndicator = () => ({
  type: HIDE_TYPING_INDICATOR,
});
